import { createApp } from 'vue'
import App from './App.vue'

// eslint-disable-next-line
createApp(App).mount('#cvp_app')
